<script setup lang="ts">
const videoEl = ref<HTMLVideoElement | null>(null);

onMounted(() => {
  const { isIos } = useDevice();
  if (!videoEl.value) return;

  // Safari requires direct user interaction
  const tryPlay = () => {
    videoEl.value?.play().catch((e) => {
      console.debug('Autoplay blocked:', e);
    });
  };

  // Attempt initial play
  tryPlay();

  // Safari workaround: Play after first interaction
  document.addEventListener('click', () => tryPlay(), { once: true });
  document.addEventListener('touchstart', () => tryPlay(), { once: true });

  // Preload technique for Safari
  if (isIos) {
    videoEl.value.load();
  }
});

// const config = useRuntimeConfig();
// const videoUrl = `https://${config.public.appEnv === "production" ? "" : "stage."}tokenizer.estate/api/video/form_decorator.mp4`;

const videoUrl = `/video/hero-decorator.mp4`;
</script>

<template>
  <section class="hero-wrapper">
    <div class="hero">
      <div class="hero-title">
        <h1 class="visually-hidden headline-1 mobile-title">
          Turning ideas into stunning RWA products
        </h1>
        <span class="headline-1 title">Turning ideas into</span>
        <span class="headline-1 title">stunning</span>
        <span class="headline-1 title">RWA products</span>
        <nuxt-link to="/#join" class="hero-link font-button-text"
          >Join Our Team</nuxt-link
        >
      </div>
    </div>
    <video
      ref="videoEl"
      class="decorator-video"
      playsinline
      webkit-playsinline
      x5-video-player-type="h5"
      muted
      loop
      autoplay
      preload="auto"
    >
      <source :src="videoUrl" type="video/mp4" />
    </video>
  </section>
</template>

<style scoped>
.hero-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--color-text);
}

.hero {
  position: relative;
  width: 100%;
  max-width: 1440px;
  height: 100vh;
  min-height: 700px;
  padding: 20px 40px 96px 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  z-index: 1;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.hero-title {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.title {
  width: 100%;
  color: var(--color-white);
  text-transform: uppercase;
  white-space: normal;
}

.title span {
  padding-left: 200px;
}

.hero-title span:first-of-type {
  padding-left: 116px;
}

.hero-title span:nth-of-type(3) {
  padding-left: 232px;
}

.decorator-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-link {
  cursor: pointer;
  text-transform: uppercase;
  position: absolute;
  bottom: 0px;
  right: 0px;
  padding: 12px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: var(--color-white);
  border: none;
  outline: none;
  color: var(--main-blue);
  text-decoration: none;
  transition: box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out;
}

.hero-link:hover {
  box-shadow: 8px 4px 40px 0 var(--main-blue);
}
.hero-link:active {
  box-shadow: 8px 4px 40px 0 var(--main-blue);
  transform: scale(0.97);
}

@media (max-width: 1200px) {
  .hero {
    padding: 20px 20px 120px 20px;
  }

  .hero-title {
    height: 100%;
    padding-top: 172px;
  }

  .hero-link {
    position: relative;
    margin-top: auto;
    width: 100%;
  }
}

@media (max-width: 1023px) {
  .title {
    display: none;
  }

  .mobile-title {
    position: relative;
    width: 100%;
    max-width: 632px;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: unset;
    clip: unset;
    border: unset;
    color: var(--color-white);
    text-transform: uppercase;
  }
}

@media (max-width: 743px) {
  .hero {
    padding: 20px 20px 120px 20px;
  }

  .hero-title {
    padding-top: 125px;
  }

  .mobile-title {
    max-width: 450px;
  }
}
</style>
